import { Box, FormControl, InputAdornment, OutlinedInput } from "@mui/material";
import React from "react";
import { RiSearch2Line } from "react-icons/ri";

function Search() {
  return (
    <Box sx={{ width: "100%", ml: { xs: 0, md: 1 } }}>
      <FormControl sx={{ width: { xs: "100%", md: 224 } }}>
        <OutlinedInput
          size="small"
          placeholder="Search anywhere"
          endAdornment={
            <InputAdornment position="start" sx={{ mr: -0.5 }}>
              <RiSearch2Line />
            </InputAdornment>
          }
        />
      </FormControl>
    </Box>
  );
}

export default Search;
